import axios from "axios"
import Swal from "sweetalert2";
import { api_urls } from "../api-urls"
import { access_token } from "../constant";

export const getAPI = async (url) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.get(api_urls + url, { headers: { Authorization: 'Bearer ' + token } })
    return response;
};

export const postAPI = async (url, payload) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.post(api_urls + url, payload, { headers: { Authorization: 'Bearer ' + token } });
    return response;
};

export const putAPI = async (url, payload) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.put(api_urls + url, payload, { headers: { Authorization: 'Bearer ' + token } });
    return response;
};

export const patchAPI = async (url, payload) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.patch(api_urls + url, payload, { headers: { Authorization: 'Bearer ' + token } });
    return response;
};

export const deleteAPI = async (url) => {
    const token = localStorage.getItem(access_token);

    const response = await axios.delete(api_urls + url, { headers: { Authorization: 'Bearer ' + token } });
    return response;
};

// downloadPDF(`api/report/get-reports`);
export const downloadPDF = async (route, payload) => {
    try {
        // const response = await axios.get(
        //     api_urls + route,
        //     {
        //         responseType: 'blob', //* Important to receive binary data
        //         headers: { Accept: 'application/pdf', },
        //         validateStatus: function (status) {
        //             return status >= 200 && status < 500; //* Allow 4xx responses for custom handling
        //         },
        //     }
        // );
        const response = await axios.post(
            api_urls + route,
            payload,
            {
                responseType: 'blob',
                headers: { Accept: 'application/pdf' },
                validateStatus: status => status >= 200 && status < 500,
            }
        );

        const contentType = response.headers['content-type'];
        // 🔍 If error response in JSON (like 404)
        if (contentType && contentType.includes('application/json')) {
            const reader = new FileReader();
            reader.onload = () => {
                const errorData = JSON.parse(reader.result);
                Swal.fire({ icon: 'info', text: errorData.message || 'PDF not found.', showConfirmButton: false });
            };
            reader.readAsText(response.data);
            return;
        }

        // ✅ Extract exact filename from Content-Disposition
        const disposition = response.headers['content-disposition'];
        let filename = 'Default-Bill.pdf';
        if (disposition) {
            const match = disposition.match(/filename\*=UTF-8''([^;]+)|filename="?([^"]+)"?/);
            if (match) {
                filename = decodeURIComponent(match[1] || match[2]);
            }
        }

        // 📥 Trigger download
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', filename);
        document.body.appendChild(link);
        link.click();

        // ♻️ Cleanup
        link.parentNode.removeChild(link);
        window.URL.revokeObjectURL(url);
        Swal.fire({ icon: 'success', text: "Generated successfully.", showConfirmButton: false });
    } catch (error) {
        console.log("Generating PDF Error :::", error);
        Swal.fire({ icon: 'error', text: error?.response?.data?.message || 'Error while generating pdf.', showConfirmButton: false });
    }
};